import { Box, FormControl, FormHelperText, TextField, Typography, Collapse, Chip, Button, useTheme } from '@mui/material'
import { ErrorMessage, Field, Form, Formik } from 'formik'
import { FLAT_COLORS, Icons } from '../../utils/utilities'
import React, { useState } from 'react'
import * as Yup from 'yup'

const headBgColor = FLAT_COLORS[Math.floor( Math.random() * FLAT_COLORS.length )]

const MaterialEdit = ( { material, currentTags, setEditMode, update, isUpdating } ) => {

    const [tags, setTags] = useState( currentTags.length === 1 ? currentTags[0] === "" ? [] : [...currentTags] : currentTags )

    const { palette } = useTheme()

    const initialValues = {
        materialName: material.study_material_name,
        materialDescription: material.study_material_desc,
        tags: currentTags.join()
    }

    const validationSchema = Yup.object().shape( {
        materialName: Yup.string().required( "Material name is required" )
    } )

    const deleteTag = ( index, setFieldValue ) => {
        const t = [...tags]
        t.splice( index, 1 )
        setTags( t )
        setFieldValue( 'tags', t.join( "," ) )
    }

    const handleKeyDown = ( e, setFieldValue ) => {
        if ( e.code === "Enter" || e.code === "Tab" ) {
            e.preventDefault()
            if ( e.target.value.trim() !== '' ) {
                let newTags = e.target.value.split( "," )
                let filteredTags = []
                newTags.forEach( tag => {
                    if ( tag.trim() !== '' ) filteredTags.push( tag )
                } )
                setTags( [...tags, ...filteredTags] )
                setFieldValue( 'tags', [...tags, ...filteredTags].join( "," ) )
                e.target.value = ""
            }
        }
    }

    const handleBlur = ( e, setFieldValue ) => {
        if ( e.target.value.trim() !== '' ) {
            let newTags = e.target.value.split( "," )
            let filteredTags = []
            newTags.forEach( tag => {
                if ( tag.trim() !== '' ) filteredTags.push( tag )
            } )
            setTags( [...tags, ...filteredTags] )
            setFieldValue( 'tags', [...tags, ...filteredTags].join( "," ) )
            e.target.value = ""
        }
    }

    return (
        <Box overflow="hidden">
            {material && <Box>
                <Box >
                    <Typography marginTop="3px" variant="h6" fontSize="18px" color="primaryDark">{material.study_material_name}</Typography>
                    <Typography variant="subtitle2" fontSize="12px" color='textSecondary' >Edit this material.</Typography>
                </Box>
                <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={update}>
                    {( { setFieldValue, values } ) => {
                        return (
                            <Box marginTop="20px">
                                <Form autoComplete='false'>
                                    <FormControl fullWidth>
                                        <Typography variant="subtitle2" color={palette.form.labelColor} gutterBottom>Material name *</Typography>
                                        <Field size="small" as={TextField} InputLabelProps={{ sx: { fontSize: "14px !important" } }} InputProps={{ sx: { fontSize: "14px !important" } }} fullWidth type="text" name="materialName" />
                                        <FormHelperText sx={{ color: "error.main", fontWeight: "bold", marginLeft: 0 }}> <ErrorMessage name="materialName" /> </FormHelperText>
                                    </FormControl>
                                    <FormControl fullWidth margin="normal" >
                                        <Typography variant="subtitle2" color={palette.form.labelColor} gutterBottom>Material description *</Typography>
                                        <Field size="small" as={TextField} InputLabelProps={{ sx: { fontSize: "14px !important" } }} InputProps={{ sx: { fontSize: "14px !important" } }} multiline rows={5} fullWidth type="text" name="materialDescription" />
                                        <FormHelperText> <ErrorMessage name="materialDescription" /> </FormHelperText>
                                    </FormControl>
                                    <FormControl fullWidth>
                                        <Typography gutterBottom color={palette.form.labelColor} fontSize="14px">Add Tags * {`(Type tags as comma seperated values)`}</Typography>
                                        <Box >
                                            <TextField type="text" size="small" placeholder='Add new tag' fullWidth onBlur={( e ) => { handleBlur( e, setFieldValue ) }} onKeyDown={e => { handleKeyDown( e, setFieldValue ) }} slotProps={{
                                                input: { sx: { fontSize: "14px !important" } }
                                            }} />
                                            <Collapse in={tags.length > 0}>
                                                {/* <Typography marginTop="10px" display="block" gutterBottom variant='subtitle2' color="secondary">Added tags</Typography> */}
                                                <Box display="flex" alignItems="center" marginTop="10px" gap="10px">
                                                    {tags.length > 0 && tags.map( ( tag, index ) => {
                                                        return (
                                                            <Chip deleteIcon={Icons.default.CloseIcon} key={index} sx={{ borderRadius: "5px", border: `2px solid ${palette.borderColor}`, background: palette.contentBg }} label={tag} onDelete={() => deleteTag( index, setFieldValue )} size="medium" />
                                                        )
                                                    } )}
                                                </Box>
                                            </Collapse>
                                        </Box>
                                    </FormControl>
                                    <Box marginTop="20px" display="flex" alignItems="center" gap="10px">
                                        <Button type="submit" sx={{ textTransform: "capitalize" }} disabled={( values.materialName.trim() === material.study_material_name.trim() && values.materialDescription.trim() === material.study_material_desc.trim() && currentTags.join( "," ).trim() === tags.join( "," ).trim() ) || isUpdating} disableElevation variant='contained'>{isUpdating ? "Saving changes..." : "Save Changes"}</Button>
                                        <Button onClick={e => { setEditMode( false ); window.location.hash = "" }} sx={{ textTransform: "capitalize" }} color='error' variant='contained' disableElevation>Cancel</Button>
                                    </Box>
                                </Form>
                            </Box>
                        )
                    }}
                </Formik>
            </Box>}
        </Box>
    )
}

export default MaterialEdit
